__turbopack_context__.v({
  "add-banner-photo-btn": "CardHeader-module-scss-module__vg2eqG__add-banner-photo-btn",
  "add-banner-photo-icon": "CardHeader-module-scss-module__vg2eqG__add-banner-photo-icon",
  "base-is-locked-overlay": "CardHeader-module-scss-module__vg2eqG__base-is-locked-overlay",
  "base-lock": "CardHeader-module-scss-module__vg2eqG__base-lock",
  "blinq-icon-path": "CardHeader-module-scss-module__vg2eqG__blinq-icon-path",
  "card-header": "CardHeader-module-scss-module__vg2eqG__card-header",
  "circle-container": "CardHeader-module-scss-module__vg2eqG__circle-container",
  "edit-banner-image-overlay": "CardHeader-module-scss-module__vg2eqG__edit-banner-image-overlay",
  "edit-popover-content": "CardHeader-module-scss-module__vg2eqG__edit-popover-content",
  "hover-text": "CardHeader-module-scss-module__vg2eqG__hover-text",
  "image-container": "CardHeader-module-scss-module__vg2eqG__image-container",
  "left-picture": "CardHeader-module-scss-module__vg2eqG__left-picture",
  "lock-btn": "CardHeader-module-scss-module__vg2eqG__lock-btn" + " " + "CardHeader-module-scss-module__vg2eqG__base-lock",
  "lock-btn-border-fade-in": "CardHeader-module-scss-module__vg2eqG__lock-btn-border-fade-in",
  "lock-message-fade-in": "CardHeader-module-scss-module__vg2eqG__lock-message-fade-in",
  "next-image": "CardHeader-module-scss-module__vg2eqG__next-image",
  "next-image-buttons": "CardHeader-module-scss-module__vg2eqG__next-image-buttons",
  "picture-label": "CardHeader-module-scss-module__vg2eqG__picture-label",
  "picture-preview": "CardHeader-module-scss-module__vg2eqG__picture-preview",
  "picture-preview-button-container": "CardHeader-module-scss-module__vg2eqG__picture-preview-button-container",
  "picture-preview-container": "CardHeader-module-scss-module__vg2eqG__picture-preview-container",
  "prevent-override-icon-container": "CardHeader-module-scss-module__vg2eqG__prevent-override-icon-container" + " " + "CardHeader-module-scss-module__vg2eqG__base-lock",
  "select-image-buttons": "CardHeader-module-scss-module__vg2eqG__select-image-buttons",
});
